/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Ai_DeepInputs */

const en_landing_pricing_compare_ai_deep = /** @type {(inputs: Landing_Pricing_Compare_Ai_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-depth research article (EN + ZH)`)
};

const zh_landing_pricing_compare_ai_deep = /** @type {(inputs: Landing_Pricing_Compare_Ai_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深度调研长文（中英双语）`)
};

/**
* | output |
* | --- |
* | "In-depth research article (EN + ZH)" |
*
* @param {Landing_Pricing_Compare_Ai_DeepInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_ai_deep = /** @type {((inputs?: Landing_Pricing_Compare_Ai_DeepInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Ai_DeepInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_ai_deep(inputs)
	return zh_landing_pricing_compare_ai_deep(inputs)
});
export { landing_pricing_compare_ai_deep as "landing.pricing.compare_ai_deep" }